module.exports = {"520425001":"松山街道","520425002":"五峰街道","520425101":"格凸河镇","520425102":"猴场镇","520425103":"猫营镇","520425104":"板当镇","520425105":"宗地镇","520425106":"大营镇","520425107":"坝羊镇","520425108":"火花镇","520425200":"白石岩乡","520425203":"四大寨乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520425.json
// module id = 2482
// module chunks = 0